module.exports = __webpack_public_path__ + "img/side-icon-12.625f8102.svg";